<template>
  <label class="bb-toggle"
         v-click-outside="hideModal"
         :class="{
           'bb-toggle_accent': type === 'accent',
           'bb-toggle_accent-small': type === 'accent-small'
         }"
         @click="checkConfirm">
    <input class="bb-toggle__checkbox"
           type="checkbox"
           v-model="statusToggle"
           :disabled="confirm || disabled">
    <span class="bb-toggle__slider"></span>
    <transition name="bounce">
      <div class="bb-toggle-modal"
           v-if="openConfirm">
        <span class="bb-toggle-modal__title">Are you sure?</span>
        <div class="bb-toggle-modal-buttons-wrapper">
          <button class="bb-toggle-modal-buttons-wrapper__button bb-button" type="submit"
                  @click.stop="toggleChange()">Yes
          </button>
          <button class="bb-toggle-modal-buttons-wrapper__button bb-button" type="submit"
                  @click.stop="hideModal()">No
          </button>
        </div>
      </div>
    </transition>
  </label>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'toggle',
  props: ['name', 'value', 'type', 'confirm', 'disabled'],
  data () {
    return {
      openConfirm: this.confirm
    }
  },
  computed: {
    statusToggle: {
      get: function () {
        return this.value
      },
      set: function (data) {
        if (!this.checkConfirm()) {
          return
        }
        this.$emit('toggleChange', data, this.name)
        this.openConfirm = false
      }
    }
  },
  methods: {
    hideModal () {
      this.openConfirm = false
      this.$emit('toggleChange', 'hide', this.name)
    },
    checkConfirm () {
      if (this.confirm) {
        return true
      }
      return _.isUndefined(this.confirm)
    },
    toggleChange () {
      this.openConfirm = false
      this.statusToggle = !this.statusToggle
    }
  },
  watch: {
    confirm () {
      this.openConfirm = this.confirm && !this.disabled
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-toggle {
    position: relative;
    display: inline-block;
    width: 21px;
    height: 11px;

    &__checkbox {
      opacity: 0;
      width: 0;
      height: 0;

      &:checked + span {
        background-color: $color-guardsman-red;
      }

      &:checked + span:before {
        transform: translateX(10px);
      }
    }

    &__slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: $color-silver;
      transition: .1s;
      border-radius: 34px;

      &:before {
        position: absolute;
        content: "";
        height: 9px;
        width: 9px;
        left: 1px;
        bottom: 1px;
        background-color: $color-white;
        transition: .2s;
        border-radius: 50%;
      }
    }

    &_accent {
      width: 37px;
      height: 20px;

      .bb-toggle {
        &__checkbox {
          &:checked + span {
            background-color: $color-accent;
          }

          &:checked + span:before {
            transform: translateX(17px);
          }
        }

        &__slider {
          border-radius: 73px;

          &:before {
            height: 14px;
            width: 14px;
            left: 3px;
            top: 3px;
            bottom: 3px;
          }
        }
      }
    }

    &_accent-small {
      width: 32px;
      height: 17px;

      .bb-toggle {
        &__checkbox {
          &:checked + span {
            background-color: $color-accent;
          }

          &:checked + span:before {
            transform: translateX(15px);
          }
        }

        &__slider {
          border-radius: 64px;

          &:before {
            height: 11px;
            width: 11px;
            left: 3px;
            top: 3px;
            bottom: 3px;
          }
        }
      }
    }

    &-modal {
      position: absolute;
      bottom: -32px;
      right: 47px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: $color-white;
      box-shadow: 0 0 15px rgba($color-black, 0.05);
      border-radius: 5px;
      z-index: 10;
      padding: 14px;
      min-width: 117px;
      height: 84px;

      &:after {
        position: absolute;
        right: -10px;
        bottom: calc(50% - 2.5px);
        content: '';
        border: 5px solid transparent;
        border-left: 5px solid $color-white;
        box-shadow: 0 0 15px rgba($color-black, 0.05);
      }

      &_top {
        bottom: 0;
        top: auto;
      }

      &_no-edit {
        right: 50px;
      }

      &__title {
        font-size: 14px;
        line-height: 17px;
      }

      &-buttons-wrapper {
        display: flex;
        justify-content: space-between;
        width: 100%;

        &__button {
          margin-top: 13px;
          width: 39px;
          height: 26px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/Inputs/toggle.vue